import { ApiFetch } from '../../../shared/utils/fetch';
import type { AuditFacets, AuditFilters, AuditListResponse } from '../types';

/** Builds a query string from filters, omitting empty/undefined params. */
const buildQuery = (filters: AuditFilters): string => {
  const entries = Object.entries(filters).filter(
    ([, v]) => v !== undefined && v !== null && v !== '',
  );
  return entries.length
    ? '?' + new URLSearchParams(entries.map(([k, v]) => [k, String(v)])).toString()
    : '';
};

export const auditApi = {
  list: async (filters: AuditFilters): Promise<AuditListResponse> =>
    ApiFetch.get<AuditListResponse>(`/audit${buildQuery(filters)}`),

  facets: async (): Promise<AuditFacets> => ApiFetch.get<AuditFacets>('/audit/facets'),
};
